// @flow
const styles = {
    attributeTableButton: {
        fontSize: 'small',
    },
    attributeTableContainer: {
        fontSize: 'smaller',
        userSelect: 'none',
    },
    attributeTableControlBar: {
        fontStyle: 'italic',
    },
    attributeTableMenuItem: {
        fontSize: 'small',
    },
    attributeTableSearch: {
        margin: 0,
    },
    attributeTableTextEdit: {
        fontSize: 'small',
        margin: 0,
        padding: 0,
    },
}

export default styles
